import type { GitHubAppConnectionResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import Dialog from "~/components/Dialog/Dialog";
import PanelRepositorySelector from "./PanelRepositorySelector";
interface GitHubConnectionRepositorySelectorProps {
    isOpen: boolean;
    closeDialog: () => void;
    connection: GitHubAppConnectionResource;
    refreshPage: () => Promise<boolean>;
}
export function GitHubConnectionRepositorySelector({ isOpen, closeDialog, connection, refreshPage }: GitHubConnectionRepositorySelectorProps) {
    return (<Dialog open={isOpen} dialogWidth={"1000px"} title="Edit Repositories">
            <PanelRepositorySelector connection={connection} closeDialog={closeDialog} refreshPage={refreshPage}/>
        </Dialog>);
}
